import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { useEffect } from 'react';
import PropTypes from 'prop-types'; // import LayerRowPeriodItem from '../LayerRowPeriodItem';

import { isPlainObject as _isPlainObject } from 'lodash';
import { jsx as _jsx } from "react/jsx-runtime";

var LayerRowItem = function LayerRowItem(_ref) {
  var layer = _ref.layer,
      LayerRowPeriodItemComponent = _ref.LayerRowPeriodItemComponent,
      height = _ref.height,
      onClick = _ref.onClick,
      top = _ref.top,
      mapKey = _ref.mapKey,
      usePeriods = _ref.usePeriods,
      periodKeys = _ref.periodKeys,
      periodsByConfig = _ref.periodsByConfig,
      activeLevel = _ref.activeLevel,
      dayWidth = _ref.dayWidth,
      getX = _ref.getX,
      mouseX = _ref.mouseX,
      period = _ref.period,
      periodLimit = _ref.periodLimit,
      vertical = _ref.vertical,
      width = _ref.width;
  var timelineParams = {
    activeLevel: activeLevel,
    dayWidth: dayWidth,
    getX: getX,
    mouseX: mouseX,
    period: period,
    periodLimit: periodLimit,
    vertical: vertical,
    width: width
  };
  useEffect(function () {
    if (_isPlainObject(layer === null || layer === void 0 ? void 0 : layer.periods) && typeof usePeriods === 'function') {
      usePeriods(layer.periods);
    }
  }, []);

  var getOverlayes = function getOverlayes() {
    if ((layer === null || layer === void 0 ? void 0 : layer.periods.length) > 0) {
      // prepare overlay for each period
      return layer.periods.map(function (period, i) {
        return /*#__PURE__*/_jsx(LayerRowPeriodItemComponent, _objectSpread({
          mapKey: mapKey,
          originPeriod: period,
          layer: layer,
          height: height,
          top: top,
          onClick: onClick
        }, timelineParams), "".concat(JSON.stringify(layer), "_").concat(JSON.stringify(period), "_").concat(i, "_LayerRowPeriodItem"));
      });
    } else if ((periodKeys === null || periodKeys === void 0 ? void 0 : periodKeys.length) > 0) {
      // prepare overlay for each period
      return periodKeys.map(function (periodKey, i) {
        var periodByConfig = periodsByConfig && periodKey ? periodsByConfig.find(function (p) {
          return p.key === periodKey;
        }) : null;

        if (periodByConfig) {
          return /*#__PURE__*/_jsx(LayerRowPeriodItemComponent, _objectSpread({
            mapKey: mapKey,
            originPeriod: periodByConfig,
            layer: layer,
            height: height,
            top: top,
            onClick: onClick
          }, timelineParams), "".concat(JSON.stringify(layer), "_").concat(periodKey, "_").concat(i, "_LayerRowPeriodItem"));
        }
      });
    } else {
      // period is not defined
      return [];
    }
  };

  var overlays = getOverlayes();
  return [overlays];
};

LayerRowItem.propTypes = {
  LayerRowPeriodItemComponent: PropTypes.elementType,
  activeLevel: PropTypes.string,
  dayWidth: PropTypes.number,
  getX: PropTypes.func,
  height: PropTypes.number,
  layer: PropTypes.shape({
    periods: PropTypes.oneOfType([PropTypes.array, PropTypes.object])
  }),
  mapKey: PropTypes.string,
  mouseX: PropTypes.number,
  onClick: PropTypes.func,
  period: PropTypes.object,
  periodKeys: PropTypes.array,
  periodLimit: PropTypes.object,
  periodsByConfig: PropTypes.array,
  top: PropTypes.number,
  usePeriods: PropTypes.func,
  vertical: PropTypes.bool,
  width: PropTypes.number
};
export default LayerRowItem;